import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GLOBAL_VARIABLES } from 'src/app/shared/data/const.data';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ThesesService } from 'src/app/services/data/theses.service';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { ThesesResource } from '../../services/data/theses.service';

@UntilDestroy()
@Component({
  selector: 'app-theses-data',
  templateUrl: './theses-data.component.html',
  styleUrls: ['./theses-data.component.css']
})
export class ThesesDataComponent implements OnInit {

  isFormReady: boolean = false;
  target: string;

  materials: string;

  results: string;

  conclusions: string;

  thesesResource: ThesesResource;

  thesesForm: UntypedFormGroup;

  initProps = GLOBAL_VARIABLES.TINY_MCE_INIT_PROPS_MINI;
  initPropsTitle = GLOBAL_VARIABLES.TINY_MCE_INIT_PROPS_TITLE;
  _alias: string = '';

  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    private thesesService: ThesesService
    ) { }

  ngOnInit(): void {
    this.isFormReady = false;
    this._route.paramMap.pipe(
      untilDestroyed(this),
      tap(data =>  this._alias = data.get('alias'))
    ).subscribe();

    this.thesesResource = this.thesesService.getTheses();

    if (this.thesesResource.mainAuthor === null){
      this.router.navigate(['/theses', this._alias]);
    }

    this.thesesForm = new UntypedFormGroup({
      titleCtrl: new UntypedFormControl(this.thesesResource?.thesesTitle, Validators.required),
      targetCtrl: new UntypedFormControl(this.thesesResource?.thesesTarget),
      materialsCtrl: new UntypedFormControl(this.thesesResource?.thesesMaterials),
      resultsCtrl: new UntypedFormControl(this.thesesResource?.thesesResults),
      conclusionsCtrl: new UntypedFormControl(this.thesesResource?.thesesConclusions)
    });

    this.isFormReady = true;

  }


  nextPage() {
    this.router.navigate(['/theses' , this._alias, 'done']);
  }

  prevPage() {
    this.router.navigate(['/theses', this._alias, 'authors']);
  }


  onSubmit(){
    this.thesesService.pushThesesData(
      this.thesesForm.controls['titleCtrl'].value,
      this.thesesForm.controls['targetCtrl'].value,
      this.thesesForm.controls['materialsCtrl'].value,
      this.thesesForm.controls['resultsCtrl'].value,
      this.thesesForm.controls['conclusionsCtrl'].value
    );

  }

}
